import { render, staticRenderFns } from "./QuienesSomos.vue?vue&type=template&id=141487ab&scoped=true&"
import script from "./QuienesSomos.vue?vue&type=script&lang=js&"
export * from "./QuienesSomos.vue?vue&type=script&lang=js&"
import style0 from "./QuienesSomos.vue?vue&type=style&index=0&id=141487ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141487ab",
  null
  
)

export default component.exports